import React, { useState, useRef, useEffect } from 'react';
import './InfoPopup.css';

interface InfoPopupProps {
  icon: React.ReactNode;
  content: string | React.ReactNode;
  id?: string;
}

const InfoPopup: React.FC<InfoPopupProps> = ({ icon, content, id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const iconRef = useRef<HTMLDivElement>(null);

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      popupRef.current && 
      !popupRef.current.contains(event.target as Node) &&
      iconRef.current && 
      !iconRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="info-popup-container">
      <div 
        className="info-icon-wrapper" 
        onClick={handleIconClick}
        ref={iconRef}
        id={id}
      >
        {icon}
      </div>
      {isOpen && (
        <div className="info-popup" ref={popupRef}>
          <div className="info-popup-content">
            {content}
          </div>
          <button 
            className="info-popup-close" 
            onClick={() => setIsOpen(false)}
            aria-label="Close popup"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};

export default InfoPopup;